export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - 兴云平台`;
  }
  return `兴云平台`;
}
